export class Identification
{
    public IsWeb : boolean;
    public License : string;
    public UserName : string;
    public MachineName : string | undefined;
    public ID: string | undefined;
    public NumeroDeSincronizacao : number = 0;

    constructor(license : string, userName : string)
    {
        this.IsWeb = true;
        this.License = license;
        this.UserName = userName;
    }
}